module.exports = {"530325001":"中安街道","530325002":"胜境街道","530325102":"营上镇","530325103":"黄泥河镇","530325104":"竹园镇","530325105":"后所镇","530325106":"大河镇","530325107":"墨红镇","530325108":"富村镇","530325109":"十八连山镇","530325110":"老厂镇","530325201":"古敢水族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530325.json
// module id = 2560
// module chunks = 0